import { render } from "./TeamHeader.vue?vue&type=template&id=5478628a"
import script from "./TeamHeader.vue?vue&type=script&lang=js"
export * from "./TeamHeader.vue?vue&type=script&lang=js"

import "./TeamHeader.vue?vue&type=style&index=0&id=5478628a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__